const recaptcha = () => {
  const { ibis } = window;

  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptcha_key).then((token) => {
        resolve(token);
      });
    });
  });
};

export default recaptcha;
